import { render, staticRenderFns } from "./create.vue?vue&type=template&id=824c1652&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('824c1652')) {
      api.createRecord('824c1652', component.options)
    } else {
      api.reload('824c1652', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=824c1652&", function () {
      api.rerender('824c1652', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/tax-payer/create.vue"
export default component.exports